import {
  FMPI_FETCH_QUESTIONS,
  FMPI_FETCH_RESULTS,
  FMPI_FETCH_TYPE,
  FMPI_SUBMIT_RESULT,
  FMPI_DELETE,
  FMPI_UPDATE,
} from "./actions";
import { AUTH_LOG_OUT_USER } from "actions/types";
import _ from "lodash";
import { AUTH_LOG_OUT_PROVIDER } from "containers/auth/Pet_Services_Portal/actions";

const INITIAL_STATE = {
  template: {},
  templateFetched: false,
  results: [],
  fetchType: "",
  fetchDates: "",
  lastFetchPetID: "",
};

export default function FmpiReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FMPI_FETCH_QUESTIONS:
      return {
        ...state,
        template: action.payload,
        templateFetched: true,
      };
    case FMPI_FETCH_TYPE:
      return {
        ...state,
        fetchDates: action.payload.dates,
        fetchType: action.payload.type,
      };
    case FMPI_FETCH_RESULTS:
      return {
        ...state,
        results: _.sortBy(action.payload, "date").reverse(),
        lastFetchPetID: action.pet._id,
      };
    case FMPI_SUBMIT_RESULT:
      return {
        ...state,
        results: _.sortBy([action.payload, ...state.results], "date").reverse(),
        fetchDates: "",
      };
    case FMPI_UPDATE:
      return {
        ...state,
        results: _.sortBy(
          [
            ...state.results.filter(
              (result) => result._id !== action.payload._id
            ),
            action.payload,
          ],
          "date"
        ).reverse(),
      };
    case FMPI_DELETE:
      return {
        ...state,
        results: state.results.filter(
          (result) => result._id !== action.payload
        ),
      };
    case AUTH_LOG_OUT_USER:
    case AUTH_LOG_OUT_PROVIDER:
      return INITIAL_STATE;
    default:
      return state;
  }
}
